(function () {
  'use strict';

  angular
    .module('fertilization.nutrientComparisonExports')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('fertilization.nutrientComparisonExports', {
        abstract: true,
        url: '/nutrient-comparison-exports',
        template: '<ui-view />'
      });
  }
}());
